module.exports = __webpack_public_path__ + "img/logo.8fc98385.png";